/**
 * Bridge to the native BiometricAuthPlugin (android/.../BiometricAuthPlugin.java).
 * Uses Capacitor's registerPlugin so no extra npm dependency is needed. Outside
 * the Android app (plain browser/dev), the native plugin doesn't exist — calls
 * resolve to { available: false } via Capacitor's web fallback, so callers should
 * always treat "not available" the same as "not successful" and fall back to the PIN.
 */
import { registerPlugin } from "@capacitor/core";

interface BiometricAuthPlugin {
  authenticate(opts: { title?: string; subtitle?: string }): Promise<{ available: boolean; success: boolean }>;
}

const BiometricAuth = registerPlugin<BiometricAuthPlugin>("BiometricAuth");

/** Resolves true only on an actual successful fingerprint match. Never throws. */
export async function tryFingerprint(subtitle: string): Promise<boolean> {
  try {
    const r = await BiometricAuth.authenticate({ title: "JARVIS", subtitle });
    return !!r?.success;
  } catch {
    return false; // plugin missing (web/dev) or any native error — caller falls back to PIN
  }
}
